<div class="tw-p-6 tw-rounded-md tw-bg-gradient-to-r tw-from-yellowLight 
            tw-via-white tw-to-yellowLight tw-mt-2 ">
    <div class="tw-text-center">
        <div class="tw-flex tw-flex-wrap tw-font-semibold tw-items-center tw-justify-center tw-text-sm md:tw-text-base">
            <p class="tw-px-3 tw-py-2 tw-bg-yellow tw-rounded-full tw-font-bold tw-text-white tw-mr-2">%</p>
            Save extra with Zero EMI Cost With
            <img src="/assets/images/HDFC_Bank_Logo.svg.png" class="tw-w-32 tw-px-2" alt="">
            Credit Cards
        </div>
        <p class="tw-text-xs md:tw-mt-2 tw-mt-4">On min value of &#8377;15,000 | No cost EMI duration 3,6 months</p>
    </div>
</div>